import componentToHex from './componentToHex.js';

const rgbToHex = function(r, g, b) {
    return `#${componentToHex(r)}${componentToHex(g)}${componentToHex(b)}`;
};

export default rgbToHex;
